// extracted by mini-css-extract-plugin
export default {"container":"styles_container__D5w0H","featured_img":"styles_featured_img__bvWAA","content":"styles_content__m-XlJ"};